import { useAuthRestApi } from '../common';
import { Observable } from 'rxjs';
import {
    IDataPackage,
    IDataPackageFileApi,
    IDisallowedExtensionsResult
} from '@vivli/shared/features/data-package/infrastructure/interface';

export const useDataPackageFileApi = (useSecureStorage = true): IDataPackageFileApi => {
    const { handleGet, handlePost, handlePut } = useAuthRestApi();
    const downloadFileUri = (
        dataPackageId: string,
        fileName: string,
        recordHistory: boolean,
        useSecureStorageOverride?: boolean
    ): Observable<string> => {
        const effective = useSecureStorageOverride !== undefined ? useSecureStorageOverride : useSecureStorage;
        return handlePost<string>(`/files/${dataPackageId}/${recordHistory}/${effective}`, fileName);
    };

    const deleteFile = (dataPackageId: string, fileName: string, useSecureStorageOverride?: boolean): Observable<IDataPackage> => {
        const effective = useSecureStorageOverride !== undefined ? useSecureStorageOverride : useSecureStorage;
        return handlePut<IDataPackage>(`/files/${dataPackageId}/deleteFile/${effective}`, fileName);
    };

    const downloadDataRequestStudyFiles = (dataRequestId: string): Observable<string> => {
        return handleGet<string>(`/files/${dataRequestId}/downloadzipfile`);
    };

    const getBadExtensionFileList = (
        dataRequestId: string,
        zipFilePath: string,
        forResultsRequest: boolean
    ): Observable<IDisallowedExtensionsResult> => {
        return handleGet<IDisallowedExtensionsResult>(`/files/${dataRequestId}/${zipFilePath}/${forResultsRequest}`);
    };

    const getBadExtensionFileListForDataPackage = (
        dataRequestId: string,
        forResultsRequest: boolean
    ): Observable<IDisallowedExtensionsResult> => {
        return handleGet<IDisallowedExtensionsResult>(`/files/${dataRequestId}/${forResultsRequest}`);
    };

    return {
        downloadFileUri,
        deleteFile,
        downloadDataRequestStudyFiles,
        getBadExtensionFileList,
        getBadExtensionFileListForDataPackage
    };
};
